import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/shared/hooks/useTheme";
import { Button } from "@/shared/ui/button";
import { cn } from "@/shared/ui/cn";
import { Icon } from "@/shared/ui/icon";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/shared/ui/tooltip";

interface ThemeToggleProps {
  variant?: "icon" | "sidebar";
  collapsed?: boolean;
}

export function ThemeToggle({ variant = "icon", collapsed = false }: ThemeToggleProps) {
  const { resolved, toggle } = useTheme();
  const next = resolved === "dark" ? "light" : "dark";
  const label = `Switch to ${next} theme`;
  const button = (
    <Button
      variant="ghost"
      size={variant === "sidebar" ? "sm" : "icon"}
      onClick={toggle}
      aria-label={label}
      className={cn(
        variant === "sidebar" && "mb-1 w-full text-fg hover:bg-surface",
        variant === "sidebar" && collapsed ? "justify-center px-0" : "justify-start",
      )}
    >
      <Icon icon={resolved === "dark" ? Sun : Moon} size={16} />
      {variant === "sidebar" && !collapsed ? (
        <span>{resolved === "dark" ? "Light theme" : "Dark theme"}</span>
      ) : null}
    </Button>
  );
  return (
    <Tooltip>
      <TooltipTrigger asChild>{button}</TooltipTrigger>
      <TooltipContent side={variant === "sidebar" ? "right" : "bottom"}>{label}</TooltipContent>
    </Tooltip>
  );
}
